import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import SignIn from './pages/sign-in';
import SignUp from './pages/sign-up';
import PartnershipNetwork from './pages/partnership-network';
import ClientPortal from './pages/client-portal';
import Contact from './pages/contact';
import PlayerProfiles from './pages/player-profiles';
import ComplianceCenter from './pages/compliance-center';
import MarketIntelligence from './pages/market-intelligence';
import SuccessStories from './pages/success-stories';
import ServicesOverview from './pages/services-overview';
import Homepage from './pages/homepage';
import PerformanceRecordsSystem from './pages/performance-records-system';
import UnifiedMetricsDashboard from './pages/unified-metrics-dashboard';
import PerformanceReports from './pages/performance-reports';
import AdminDashboard from './pages/admin-dashboard';
import LiveTransferMarketplace from './pages/live-transfer-marketplace';
import DealTrackingDashboard from './pages/deal-tracking-dashboard';
import MarketValueAnalytics from './pages/market-value-analytics';
import AIMatchRecommendationEngine from './pages/ai-match-recommendation-engine';
import NotificationCenter from './pages/notification-center';
import AdminPanelDashboard from './pages/admin-panel-dashboard';
import AdminPlayerVerification from './pages/admin-player-verification';
import PublicPlayerPortfolio from './pages/public-player-portfolio';
import PlayerRegistrationForm from './pages/player-registration-form';
import AdminAuditDashboard from './pages/admin-audit-dashboard';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public routes */}
        <Route path="/" element={<Homepage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services-overview" element={<ServicesOverview />} />
        <Route path="/success-stories" element={<SuccessStories />} />
        <Route path="/compliance-center" element={<ComplianceCenter />} />
        <Route path="/public-player-portfolio/:playerId" element={<PublicPlayerPortfolio />} />
        <Route path="/player-registration-form" element={<PlayerRegistrationForm />} />
        
        {/* Protected routes - require authentication */}
        <Route path="/notification-center" element={
          <ProtectedRoute>
            <NotificationCenter />
          </ProtectedRoute>
        } />
        <Route path="/client-portal" element={
          <ProtectedRoute>
            <ClientPortal />
          </ProtectedRoute>
        } />
        <Route path="/performance-records-system" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <PerformanceRecordsSystem />
          </ProtectedRoute>
        } />
        <Route path="/unified-metrics-dashboard" element={
          <ProtectedRoute allowedRoles={['scout', 'club', 'admin']}>
            <UnifiedMetricsDashboard />
          </ProtectedRoute>
        } />
        <Route path="/performance-reports" element={
          <ProtectedRoute allowedRoles={['scout', 'club', 'admin']}>
            <PerformanceReports />
          </ProtectedRoute>
        } />
        <Route path="/player-profiles" element={
          <ProtectedRoute allowedRoles={['scout', 'club', 'player', 'coach', 'admin']}>
            <PlayerProfiles />
          </ProtectedRoute>
        } />
        <Route path="/admin-dashboard" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin-player-verification" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminPlayerVerification />
          </ProtectedRoute>
        } />
        <Route path="/market-intelligence" element={
          <ProtectedRoute allowedRoles={['scout', 'club', 'admin']}>
            <MarketIntelligence />
          </ProtectedRoute>
        } />
        <Route path="/partnership-network" element={
          <ProtectedRoute allowedRoles={['scout', 'club', 'admin']}>
            <PartnershipNetwork />
          </ProtectedRoute>
        } />
        <Route path="/live-transfer-marketplace" element={
          <ProtectedRoute allowedRoles={['scout', 'club', 'admin']}>
            <LiveTransferMarketplace />
          </ProtectedRoute>
        } />
        <Route path="/deal-tracking-dashboard" element={
          <ProtectedRoute allowedRoles={['scout', 'club', 'admin']}>
            <DealTrackingDashboard />
          </ProtectedRoute>
        } />
        <Route path="/market-value-analytics" element={
          <ProtectedRoute allowedRoles={['scout', 'club', 'admin']}>
            <MarketValueAnalytics />
          </ProtectedRoute>
        } />
        <Route path="/ai-match-recommendation-engine" element={
          <ProtectedRoute allowedRoles={['scout', 'club', 'admin']}>
            <AIMatchRecommendationEngine />
          </ProtectedRoute>
        } />
        <Route path="/admin-panel-dashboard" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminPanelDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin-audit-dashboard" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminAuditDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
